<template>
  <div>
    <CCard>
      <CCardHeader>
        <slot name="header">
          <CIcon name="cil-grid" />
          {{title}}
        </slot>
      </CCardHeader>
      <CCardBody>
        <Loading v-if="isLoading"></Loading>
        <div v-else>
          <CForm>
          <CRow>
            <CCol sm="12">
              <CRow>
                <CCol sm="3">
                  <CInput label="Seller Code" invalid-feedback="Seller Code should be filled" :readonly="true" v-model="$v.agentForm.agent_code.$model" :is-valid="!$v.agentForm.agent_code.$invalid"/>
                </CCol>
                <CCol sm="3">
                  <CInput label="Seller Name" invalid-feedback="Seller name should be filled" :readonly="isReadonly" required v-model="$v.agentForm.name.$model" :is-valid="!$v.agentForm.name.$invalid"/>
                </CCol>
                <CCol sm="3">
                  <CInput label="Seller Alias" invalid-feedback="Seller alias should be filled" :readonly="isReadonly" required v-model="$v.agentForm.alias.$model" :is-valid="!$v.agentForm.name.$invalid"/>
                </CCol>
                <CCol sm="3">
                  <CInput label="Email" invalid-feedback="Email should be filled" :readonly="isReadonly" required v-model="$v.agentForm.email.$model" :is-valid="!$v.agentForm.email.$invalid"/>
                </CCol>
              </CRow>
              <CRow>
                 <CCol sm="3">
                  <CInput label="Mobile Phone" invalid-feedback="Mobile Phone should be filled" :readonly="isReadonly" required v-model="$v.agentForm.mobile_phone.$model" :is-valid="!$v.agentForm.mobile_phone.$invalid"/>
                </CCol>
                <CCol sm="3">
                  <CInput label="Phone Number" v-model="$v.agentForm.phone_number.$model" :readonly="isReadonly" :is-valid="!$v.agentForm.phone_number.$invalid"/>
                </CCol>
                <CCol sm="3">
                  <CInput label="Latitude" invalid-feedback="Latitude should be filled" :readonly="isReadonly" required v-model="$v.agentForm.lat.$model" :is-valid="!$v.agentForm.lat.$invalid"/>
                </CCol>
                <CCol sm="3">
                  <CInput label="Longitude" invalid-feedback="Longitude should be filled" v-model="$v.agentForm.long.$model" :readonly="isReadonly" :is-valid="!$v.agentForm.long.$invalid"/>
                </CCol>
              </CRow>

              <CRow>
                <CCol sm="3">
                  <CInput label="Address" invalid-feedback="Address should be filled" required v-model="$v.agentForm.address.$model" :readonly="isReadonly" :is-valid="!$v.agentForm.address.$invalid"/>
                </CCol>

                <CCol sm="3">
                  <div class="form-group">
                    <label for="status">Seller Status</label>
                    <model-select class="form-control" id="status" :options="agentStatusList" v-model="$v.agentForm.status.$model" :isError="$v.agentForm.status.$invalid" placeholder="-- Harap pilih salah satu --"></model-select>
                    <div v-if="$v.agentForm.status.$invalid" class="invalid-feedback-custom">Seller Status should be filled.</div>
                  </div>
                </CCol>

                <CCol sm="3">
                  <div class="form-group">
                    <label for="is_parent">Is Parent?</label>
                    <model-select 
                      class="form-control" 
                      id="is_parent" 
                      :options="agentParentList" 
                      v-model="$v.agentForm.parent_flag.$model"
                      @input="changeChild" 
                      :isDisabled ="isReadonly"
                      placeholder="-- Harap pilih salah satu --">
                    </model-select>
                    <div v-if="$v.agentForm.parent_flag.$invalid" class="invalid-feedback-custom">Child_Of should be filled.</div>
                  </div>
                </CCol>

                <CCol sm="3" v-if="noParent">
                  <div class="form-group">
                    <label for="child_of">Child of</label>
                    <model-select 
                      class="form-control" 
                      id="child_of" 
                      :isDisabled="isReadonly" 
                      :options="childofList" 
                      v-model="$v.agentForm.parent.$model" 
                      :isError="$v.agentForm.parent.$invalid" 
                      placeholder="-- Harap pilih salah satu --">
                    </model-select>
                    <div v-if="$v.agentForm.parent.$invalid" class="invalid-feedback-custom">Child_Of should be filled.</div>
                  </div>
                </CCol>
              </CRow>

              <CRow>
                <CCol sm=6>
                  <label for="nik">Description</label>
                  <quill-editor
                    style="height: 200px; margin-bottom: 70px"
                    :content="content"
                    :options="editorOption"
                    v-model="$v.agentForm.description.$model"
                    :disabled="isReadonly"
                    @change="onEditorChange($event)"
                  >
                  </quill-editor>
                  <br />
                  <div
                    v-if="$v.agentForm.description.$invalid"
                    class="invalid-feedback-custom"
                  >
                    Description harus di isi.
                  </div>
                </CCol>
                <CCol sm="3">
                  <CInput type="number" label="Minimal Purchase" invalid-feedback="Minimal Purchase should be filled" :readonly="isReadonly" required v-model="$v.agentForm.minimal_purchase.$model" :is-valid="!$v.agentForm.minimal_purchase.$invalid"/>
                </CCol>
              </CRow>
            </CCol>
          </CRow>
        </CForm>
        </div>
      </CCardBody>
      <CCardFooter align="right" :border-color="'white'">
        <CRow>
          <CCol sm="12">
            <CButton color="danger" title="Edit" size="sm" class="text-center" @click="back">
              <i class="fa fa-undo"></i> Back
            </CButton>&nbsp;
            <CButton
              color="success"
              :disabled="$v.agentForm.$invalid"
              title="Detail"
              size="sm"
              @click="save"
            >
              <i class="fa fa-edit" /> Save
            </CButton>
          </CCol>
        </CRow>
      </CCardFooter>
    </CCard>

    <CCard>
      <CCardBody>
        <CTabs :active-tab.sync="activeTab">
          <CTab active>
            <template slot="title">Coverage</template>
            <br />
            <AgentCoverage :agent="agentForm" :provinceList="provinceList" :agentCoverage="agentCoverageList"></AgentCoverage>
          </CTab>
          <CTab>
            <template slot="title">Generate Password</template>
            <br />
            <GeneratePassword :agent="agentForm" :agentPassword="agentPasswordList" :enableAdd="enableGeneratePassword"></GeneratePassword>
          </CTab>
           <CTab>
            <template slot="title">Payment Methods</template>
            <br />
            <PaymentMethod :agent="agentForm" :paymentMethodList="paymentMethodList" :agentPaymentMethod="agentPaymentMethodList"></PaymentMethod>
          </CTab>
          <CTab>
            <template slot="title">Customer Coverage</template>
            <br />
            <CustomerCoverage :agent="agentForm" :customerCoverageList="customerCoverageList" :agentCustomerCoverage="agentCoverageUserList"></CustomerCoverage>
          </CTab>
          <CTab>
            <template slot="title">Delivery Method</template>
            <br />
            <AgentDeliveryMethod :agent="agentForm" :deliveryMethodList="deliveryMethodList" :agentdeliveryMethod="agentdeliveryMethodList"></AgentDeliveryMethod>
          </CTab>
        </CTabs>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import GlobalTable from "@/templates/Table";
import tableInterfaces from "@/templates/_table_interfaces.js";
import Loading from "@/templates/Loading";
import { required } from "vuelidate/lib/validators";

import AgentCoverage from "./tabs/AgentCoverage";
import GeneratePassword from "./tabs/GeneratePassword";
import PaymentMethod from "./tabs/PaymentMethod";
import CustomerCoverage from "./tabs/CustomerCoverage";
import AgentDeliveryMethod from "./tabs/AgentDeliveryMethod";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";

export default {
  name: "AgentDetail",
  components: { GlobalTable, Loading, quillEditor, AgentCoverage, GeneratePassword, PaymentMethod, CustomerCoverage, AgentDeliveryMethod},
  data() {
    return {
      title: "Seller Detail",
      agentCoverageList: [],
      agentPasswordList: [],
      agentPaymentMethodList: [],
      agentCoverageUserList:[],
      agentdeliveryMethodList:[],
      enableGeneratePassword: true,
      agentForm: tableInterfaces.agent,
      isLoading: false,
      noParent: false,
      activeTab: 0,
      provinceList: [],
      agentStatusList: [],
      paymentMethodList: [],
      customerCoverageList:[],
      deliveryMethodList:[],
      agentStatus: "",
      agentParentList: [
        { value: "1", text: "Yes" },
        { value: "2", text: "No" },
      ],
      childofList:[],
      editorOption: {}, // data quill
      content:'',
      //enableAddPrice: true,
    };
  },
  validations: {
    agentForm: {
      agent_code: {required},
      name: { required },
      alias:{},
      email: { required },
      description: {},
      mobile_phone: { required },
      phone_number: {},
      address: { required },
      status: {required},
      lat: {required},
      long: {required},
      minimal_purchase:{required},
      parent_flag:{},
      parent:{},
    }
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  computed: {
    isReadonly: function () {
      return this.agentStatus === "1" ? true : false;
    },
  },
  methods: {
    init: function (id) {
      this.getParent();
      this.getAgentDetail(id);
      this.getProvinceList();
      this.getPaymentMehodList();
      this.getAgentCoverage(id);
      this.getAgentPassword(id);
      this.getAgentPaymentMethod(id);
      this.getAgentCustomerCoverage(id);
      this.getagentdeliveryMethodList(id);
      this.getCustomerCoverageList();
      this.getdeliveryMethodList();
      this.getAgentStatusList();
    },
     back: function () {
      this.$router.go(-1);
    },
    resetForm: function () {
      for (var i in tableInterfaces.agent) {
        tableInterfaces.agent[i] = null;
      }
      this.agentForm = tableInterfaces.agent;
    },
     getPaymentMehodList: function(){
      this.axios.get("console/dropdown/payment_method_list").then((response) => {
        this.paymentMethodList = response.data.data;
      });
    },
     getCustomerCoverageList: function(){
      this.axios.get("console/dropdown/user-group").then((response) => {
        this.customerCoverageList = response.data.data;
      });
    },
    getdeliveryMethodList: function(){
      this.axios.get("console/dropdown/delivery-method").then((response) => {
        this.deliveryMethodList = response.data.data;
      });
    },
    getProvinceList: function(){
      this.axios.get("console/dropdown/province").then((response) => {
        this.provinceList = response.data.data;
      });
    },
    getAgentDetail: function (id) {
      this.isLoading = true;
      this.resetForm();
      this.axios
        .get("console/agent/detail/" + id)
        .then((response) => {
          if (response.data.status === 2000) {
            this.agentForm = response.data.data;
            // console.log(response.data.data)

            // this variable used for calling status
            this.agentStatus = response.data.data.status;

            // console.log(response.data.data.parent)
            // console.log(this.agentForm.parent.length)

            if(response.data.data.parent_flag === '2'){
              this.noParent = true
              this.agentForm.parent = response.data.data.parent
            }

            // alert(this.agentForm);
            // this.agentForm.agent_code = response.data.data.agent_code;

            // console.log('this done?')
            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    changeChild: function (event) {
      if(event === '1'){
        this.noParent = false
        this.agentForm.parent = null
      }else{
        this.noParent = true
      }
    },
    save: function (evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin merubah Data ini ?")) {
        this.isLoading = true;
        this.axios
          .put("console/agent/update", this.agentForm)
          .then((response) => {
            this.showInfoNotification({
              title: "Ubah Seller",
              message: response.data.message,
            });
          })
          .catch((error) => {
            this.expired(error, "Ubah Seller");
          })
          .finally(() => {
            this.isLoading = false;
            let route = this.$route.path.split("/");
            this.init(route[4]);
          });
      }
    },
    getAgentCoverage: function (id) {
      this.isLoading = true;
      this.axios
        .get("console/agent/agent_coverage/listing/" + id)
        .then((response) => {
          if (response.data.status === 2000) {
            this.agentCoverageList = response.data.data;
            
            // this.showInfoNotification({
            //   title: this.title,
            //   message: response.data.message,
            // });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getAgentPaymentMethod: function (id) {
      this.isLoading = true;
      this.axios
        .get("console/agent/agent_payment_method/listing/" + id)
        .then((response) => {
          if (response.data.status === 2000) {
            this.agentPaymentMethodList = response.data.data;
            // this.showInfoNotification({
            //   title: this.title,
            //   message: response.data.message,
            // });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getAgentCustomerCoverage: function (id) {
      this.isLoading = true;
      this.axios
        .get("console/agent/agent_coverage_user/listing/" + id)
        .then((response) => {
          if (response.data.status === 2000) {
            this.agentCoverageUserList = response.data.data;
            // this.showInfoNotification({
            //   title: this.title,
            //   message: response.data.message,
            // });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getagentdeliveryMethodList: function (id) {
      this.isLoading = true;
      this.axios
        .get("console/agent/agent_delivery_method/listing/" + id)
        .then((response) => {
          if (response.data.status === 2000) {
            this.agentdeliveryMethodList = response.data.data;
            // this.showInfoNotification({
            //   title: this.title,
            //   message: response.data.message,
            // });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getAgentPassword: function (id) {
      this.isLoading = true;
      this.axios.get("console/agent/agent_password/listing/" + id).then((response) => {
        if (response.data.status === 2000) {
          this.agentPasswordList = response.data.data;
          if(this.agentPasswordList.length > 0 ){
            this.enableGeneratePassword = false;
          }else{
            this.enableGeneratePassword = true;
          }
          // if (response.data.total_row.total_row == 2) {
          //   this.enableAddPrice = false;
          // }
          // this.showInfoNotification({
          //   title: this.title,
          //   message: response.data.message,
          // });
        } else {
          // this.showErrorNotification({
          //   title: this.title,
          //   message: response.data.message,
          // });
        }
      }).catch((error) => {
        this.showErrorNotification({
          title: this.title,
          message: error,
        });
      }).finally(() => {
        this.isLoading = false;
      });
    },
    getAgentStatusList: function(){
      this.axios.get("/console/agent/status/listing").then((response) => {
        this.agentStatusList = response.data.data;
      });
    },
    getParent: function () {
      this.axios.get("/console/dropdown/agent_parent").then((response) => {
        // console.log(response)
        this.childofList = response.data.data;
      });
    },
    onEditorChange({ quill, html, text }) {
      this.content = html;
      this.agentForm.description = html;
    },
  },
  mounted() {
    let route = this.$route.path.split("/");
    this.init(route[4]);
  },
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
.ui.selection.dropdown.disabled {
  background-color: #d8dbe0;
  opacity: 0.8;
}
.ql-disabled .ql-editor{
  background-color:#d8dbe0;
}
</style>